var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-wrap",attrs:{"id":"scroll-wrap"}},[_c('div',{staticClass:"notMore",on:{"click":_vm.loadMore}},[_vm._v(_vm._s(_vm.noMore ? '没有更多了' : '加载更多'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }